import { forwardRef } from "react";

const block = (e) => e.preventDefault();

export const ProtectedImg = ({ className = "", alt = "", ...props }) => (
  <img {...props} alt={alt} draggable={false} onContextMenu={block} onDragStart={block} className={`select-none ${className}`} />
);

// mp4 (H.264 baseline) first, WebM/VP9 fallback; onLoadError fires only when no source can play
export const ProtectedVideo = forwardRef(({ mp4, webm, onLoadError, src, ...props }, ref) => {
  const handleError = (e) => {
    const t = e.target;
    if (t.tagName === "SOURCE" && t.nextElementSibling) return;
    onLoadError?.(e);
  };
  return (
    <video ref={ref} {...props} onError={handleError} onContextMenu={block} controlsList="nodownload noplaybackrate" disablePictureInPicture>
      {mp4 && <source src={mp4} type="video/mp4" />}
      {webm && <source src={webm} type="video/webm" onError={handleError} />}
      {src && !mp4 && <source src={src} onError={handleError} />}
    </video>
  );
});

export const MediaError = ({ testid = "media-error", children = "Preview couldn't play" }) => (
  <div role="alert" data-testid={testid} className="absolute inset-x-0 bottom-0 bg-black/75 px-4 py-2 text-center font-mono text-[0.65rem] uppercase tracking-[0.2em] text-[#E07A6B] backdrop-blur-md">
    {children}
  </div>
);
